export const GET_SKILLS_START = 'GET_SKILLS_START';
export const GET_SKILLS_SUCCESS = 'GET_SKILLS_SUCCESS';
export const GET_SKILLS_FAIL = 'GET_SKILLS_FAIL';

export const GET_USER_SKILLS_START = 'GET_USER_SKILLS_START';
export const GET_USER_SKILLS_SUCCESS = 'GET_USER_SKILLS_SUCCESS';
export const GET_USER_SKILLS_FAIL = 'GET_USER_SKILLS_FAIL';
